import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiForumListContainerComponent } from '@fi-shared/fi-forum/fi-forum-list/fi-forum-list-container.component';
import { FiForumListComponent } from '@fi-shared/fi-forum/fi-forum-list/fi-forum-list.component';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiStateSrefModule } from '@fi-shared/fi-state-proxy/state-sref/state-sref.module';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiItemsListModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
        FiFormatDateModule,
        FiWhenScrolledModule,
        MatCardModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        FiLocalSearch2Module,
        FiStateSrefModule,
        FiButtonBackNewModule,
        FiProfileIconModule,
        FiLineClampModule,
    ],
    declarations: [FiForumListContainerComponent, FiForumListComponent],
    exports: [FiForumListComponent],
})
export class FiForumListModule {}
